import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CryptoModeState {
  enabled: boolean;
}

const initialState: CryptoModeState = {
  enabled: false,
};

const cryptoModeSlice = createSlice({
  name: 'cryptoMode',
  initialState,
  reducers: {
 
    toggleCrypto: (state) => {
      state.enabled = !state.enabled;
    },
   
  },
});

export default cryptoModeSlice.reducer;
export const { toggleCrypto} = cryptoModeSlice.actions;
